export const environment = {
  production: false,
  appName: 'Elite Taxi Ride Hailing',
  logoUrl: 'assets/layout/images/elite-cab.png',
  tenantId: '682ba183-a759-4461-8505-1ad35aeb042b',
  apiUrl: 'https://admin.panel.transport.elite-tele.com',
  googleMapsApiKey: 'AIzaSyAAhLlK1TX5nHSiIJ1P4GQ2EkvQiY_1oBY',
  // Support calls (console, /support-calls, menu entry, "Call driver") stay hidden until the feature is ready.
  supportCalls: false,
};
